<nav class="bg-white flex flex-col justify-between h-full">
  @if (hasMenu$ | async) {
    <fr-sidebar-header
      [application]="activeApplication$ | async"
      [currentLang]="currentLang"
      [expanded]="expanded$ | async"
    ></fr-sidebar-header>
  }

  <div class="flex-auto overflow-auto">
    <fr-sidebar-route-list
      (removeRoute)="onRemoveRoute($event[0], $event[1])"
      [expanded]="expanded$ | async"
      [routes]="staticRoutes$ | async"
    ></fr-sidebar-route-list>

    @if ((staticRoutes$ | async)?.length > 0) {
      <mat-divider></mat-divider>
    }

    @if (expanded$ | async) {
      <fr-sidebar-action-list [actions]="actions$ | async"></fr-sidebar-action-list>
    }

    @if (expanded$ | async) {
      <mat-divider></mat-divider>
    }

    @if (expanded$ | async) {
      <fr-sidebar-category-route-list
        (removeRoute)="onRemoveRoute($event[0], $event[1])"
        [expanded]="expanded$ | async"
        [routeCategoryItems]="dynamicRouteCategoryItems$ | async"
      ></fr-sidebar-category-route-list>
    }

    @if ((expanded$ | async) === false) {
      <mat-action-list>
        @if ((actions$ | async)?.length > 0) {
          <button [matMenuTriggerFor]="m.menu" [title]="'frame.next' | transloco"
                  mat-list-item>
            <mat-icon>more_horiz</mat-icon>
          </button>
        }
        <fr-sidebar-action-menu #m="actionMenu" [actions]="actions$ | async"></fr-sidebar-action-menu>
        @for (routeCategoryItem of dynamicRouteCategoryItems$ | async; track routeCategoryItem) {
          @if ((staticRoutes$ | async)?.length > 0) {
            <button
              [matMenuTriggerFor]="m.menu"
              [title]="routeCategoryItem.category.label | transloco"
              mat-list-item
            >
              <mat-icon matListItemIcon>{{ routeCategoryItem.category.icon }}</mat-icon>
            </button>
          }
          <fr-sidebar-route-menu #m="routeMenu" [routes]="routeCategoryItem.routes"></fr-sidebar-route-menu>
        }
      </mat-action-list>
    }
  </div>

  <fr-sidebar-footer
    (toggleExpand)="onToggleExpand()"
    [expanded]="expanded$ | async"
    [version]="version$ | async"
  ></fr-sidebar-footer>
</nav>
